import { render, staticRenderFns } from "./manufacturingBond.vue?vue&type=template&id=0be464a3&scoped=true&"
import script from "./manufacturingBond.vue?vue&type=script&lang=js&"
export * from "./manufacturingBond.vue?vue&type=script&lang=js&"
import style0 from "./manufacturingBond.vue?vue&type=style&index=0&id=0be464a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be464a3",
  null
  
)

export default component.exports